import Vue from 'vue'
import BaseSetting from './wxconfig'
Vue.use(BaseSetting)
